"use client";
import ImageCustom from '@/components/Image'
import { LinkType } from '@/libs/types'
import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'
import { usePathname } from "next/navigation";



interface LinkCustomizedProps {
    linked: LinkType
    locale: string
    className?: string
    clicker?: () => void
}

const LinkCustomized: React.FC<LinkCustomizedProps> = ({
    linked,
    locale,
    children,
    className,
    clicker = undefined
}) => {
    const pathname = usePathname();
    const { href, icon, text, target, button }: LinkType = linked
    const partHref = `/${href.split(',').join('/')}`
    const overrideHref: string = target === "_self" ? `/${locale}`+partHref : href

    const overrideClass: string = clsx(
        className,
        pathname?.startsWith(partHref) && "text-primary",
        "d-block",
        "text-decoration-none",
        button ? "btn text-light" : ""
    )
   

    return (
        <Link href={overrideHref}
            onClick={!clicker ? undefined : clicker}
            target={target}
            className={overrideClass}
            passHref
        >
            {!!icon ? <ImageCustom alt={text}
                src={icon}
                width={24}
                height={24}
                aspectratio="1:1" /> : text}
            {!!children ? children : null}
        </Link>
    )
} 
// text-primary

export default LinkCustomized
